import React, { useState } from 'react';

import IcStarFill from '../../components/Svg/IcStarFill';
import IcStarLine from '../../components/Svg/IcStarLine';

import styles from './style.module.css'

const StarRate = props => {

  const { rate, setRate = () => { }, readonly = false } = props

  let stars = []
  for (let i = 0; i < 5; i++) {
    stars.push(
      <span onClick={() => setRate(i + 1)} className={`${styles.star} ${readonly && styles.readonly}`}>
        {rate >= i + 1 ? <IcStarFill /> : <IcStarLine />}
      </span>
    )
  }

  return (
    <div {...props}>
      {stars}
      <input type="hidden" value={rate} name="rate" />
    </div>
  )
}

export default StarRate 